import { useTranslation } from "react-i18next";
import { Logo } from "../../assets";

/**
 * The terms of services page
 *
 * @returns {JSX.Element}
 */

const TermsOfService = () => {
  const [t] = useTranslation("global");

  return (
    <main className="md:mt-15 mt-10 px-20 w-full">
      <img
        src={Logo}
        className="w-18 md:h-22 sm:h-14 mx-auto mb-8"
        alt="Camelo Logo"
      />
      <h1 className="text-text_steel_blue font-bold text-center text-2xl md:text-4xl">
        {t("term.term_condition_text")}
      </h1>
      <h2 className="font-bold mt-8 text-xl">{t("term.intro_text")}</h2>
      <p className="mt-4 text-base">{t("term.first_welcome_text")}</p>
      <h2 className="font-bold mt-8 text-lg">{t("term.accept_text")}</h2>
      <p className="mt-4 text-base">{t("term.second_your_text")}</p>
      <h2 className="font-bold mt-8 text-xl">{t("term.condition_text")}:</h2>
      <h2 className="font-bold mt-3 text-lg">{t("term.account_text")}</h2>
      <p className="mt-3">{t("term.third_must_text")}</p>

      <h2 className="font-bold mt-8 text-lg">{t("term.booking_text")}</h2>
      <p className="mt-3">{t("term.booking_p1_text")}</p>
      <p className="mt-3">{t("term.booking_p2_text")}</p>
      <p className="mt-3">{t("term.booking_p3_text")}</p>
      <h2 className="font-bold mt-8 text-lg">{t("term.liability_text")}:</h2>
      <p className="mt-3">{t("term.liability_p1_text")}</p>
      <p className="mt-3">{t("term.liability_p2_text")}</p>
      <h2 className="font-bold mt-8 text-lg">{t("term.modification_text")}</h2>
      <p className="mt-3">{t("term.modification_p_text")}</p>
      <h2 className="font-bold mt-8 text-lg">{t("term.jurisdiction_text")}</h2>
      <p className="mt-3">{t("term.jurisdiction_p_text")}</p>
      <h2 className="font-bold mt-8 text-lg">{t("term.note_text")}</h2>
      <p className="mt-3">{t("term.note_p1_text")}</p>
      <p className="mt-3">{t("term.note_p2_text")}</p>
      <p className="mt-3">{t("term.note_p3_text")}</p>
    </main>
  );
};

export default TermsOfService;
